import { useMemo } from "react";
import { IAbsenceTypeListItem } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

interface IAbsenceTypeGroup {
  groupId: string;
  groupName: string;
  groupColor: string;
  groupOrder: number;
  absenceTypes: IAbsenceTypeListItem[];
}

export const useFilteredAbsenceTypes = (
  groups: IAbsenceTypeGroup[],
  searchQuery: string
): IAbsenceTypeGroup[] =>
  useMemo(() => {
    if (!searchQuery.trim()) {
      return groups;
    }

    const lowerQuery = searchQuery.toLowerCase();

    return groups
      .map((group) => ({
        ...group,
        absenceTypes: group.absenceTypes.filter(
          (type) =>
            type.name.toLowerCase().includes(lowerQuery) ||
            type.description?.toLowerCase().includes(lowerQuery)
        ),
      }))
      .filter((group) => group.absenceTypes.length > 0);
  }, [groups, searchQuery]);
